// commerceLogoService — el logo del comercio para impresión Web Bluetooth sale DIRECTO de la URL
// del CDN (commerce.logotipo), sin pasar por backend.
//
// Histórico: existía un endpoint `GET /v1/comercio/logo` que devolvía el logo en base64 (data:
// URI) porque la URL del CDN estaba bloqueada por CORS — al rasterizarla en canvas, getImageData
// lanzaba (taint) y el logo se omitía en silencio. Esa restricción YA NO aplica: CloudFront sirve
// el logo con `Access-Control-Allow-Origin` en un GET simple, y el pipeline de rasterizado
// (loadDrawableImage: fetch{mode:'cors'} → blob → createImageBitmap) descarga los bytes SIN
// taintear el canvas. Por eso se eliminó el endpoint base64 + su caché en localStorage: la fuente
// del logo es la propia URL del CDN, que el canvas/raster descarga header-less (sin Authorization
// → sin preflight CORS).
//
// NOTA: el nombre conserva el sufijo `DataUri` por compatibilidad con los callers; hoy devuelve la
// URL del CDN (string http(s)), que el pipeline de canvas/raster y los `<img>` consumen igual.
// Rename a `getCommerceLogoUrl` queda como limpieza opcional.

// Resuelve la fuente del logo del comercio para impresión/preview: la URL del CDN
// (commerce.logotipo) tal cual. Devuelve null si no hay comercio cargado o el comercio no tiene
// logo. Async por contrato con los callers (hacen .then()/await); NUNCA lanza.
export async function getCommerceLogoDataUri(
  commerceId: string | number | null | undefined,
  logotipoUrl: string | null | undefined,
): Promise<string | null> {
  // Sin comercio cargado o sin logo configurado: no hay logo que imprimir.
  if (!commerceId || !logotipoUrl) return null;
  return logotipoUrl;
}
